<template>
  <div class="siderbar" v-if="isTopSideMenu">
    <div  class='side-nav' :style='isMobile?"width:100%;":isCollapse?"":"width:180px;"'>
      <div class="sidebar-logo">
        <img v-if="!isCollapse" :class="{'onactive':!isCollapse}" src="../../assets/img/logo@2x.png" alt="" class="logo-big">
        <img v-if="isCollapse" src="../../assets/img/logo-min.png" alt="" class="logo-min">
      </div>

      <el-menu class="sidebar-el-menu"
        :default-active="$route.path"
        :class='isMobile ? "": "el-menu-vertical-demo"'
        :collapse="isCollapse"
        background-color="#2A303F"
        text-color="#bfcbd9"
        active-text-color="#20a0ff"
      unique-opened router>
        <template v-for="item in menuList">
          <template v-if="item.subs">
            <el-submenu :index="item.index" :key="item.index">
              <template slot="title">
                <i :class="item.icon"></i><span slot="title">{{ item.title }}</span>
              </template>
              <template v-for="subItem in item.subs">
                <el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.index">
                  <template slot="title">{{ subItem.title }}</template>
                  <el-menu-item v-for="(threeItem,i) in subItem.subs" :key="i" :index="threeItem.index">
                    {{ threeItem.title }}
                  </el-menu-item>
                </el-submenu>
                <el-menu-item v-else :index="subItem.index" :key="subItem.index">
                  {{ subItem.title }}
                </el-menu-item>
              </template>
            </el-submenu>
          </template>
          <template v-else>
            <el-menu-item :index="item.index" :key="item.index">
              <i :class="item.icon"></i><span slot="title">{{ item.title }}</span>
            </el-menu-item>
          </template>
        </template>
      </el-menu>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  import {getMenuList} from '@/api/login/login';
  import bus from './bus';
  import { mapGetters } from 'vuex';
  export default {
    data () {
      return {
        collapse: false,
        queryId: '',
        menuList: [],
        // menuList: [
        //   { icon: 'iconfont home ', index: '/home', title: '首页' },
        //   {
        //     icon: 'iconfont liebiao',
        //     index: 'table',
        //     title: '列表详情',
        //     subs: [
        //       { index: '/DetailList/needTotal', title: '需求统计' },
        //       { index: '/DetailList/needList', title: '需求列表' },
        //       { index: '/DetailList/needsComment', title: '需求评价' },
        //       { index: '/DetailList/needsStarTag', title: '评价标签' },
        //       { index: '/DetailList/needsComplaint', title: '需求投诉' },
        //       { index: '/DetailList/ComplaintOption', title: '投诉选项' },
        //       { index: '/DetailList/truckDetail', title: '货运信息' },
        //     ]
        //   },
        //   {
        //     icon: 'iconfont contents ',
        //     index: 'ConteMange',
        //     title: '内容管理',
        //     subs: [
        //       { index: '/ConteMange/Article', title: '文章管理' },
        //       { index: '/ConteMange/ddHeadlines', title: '叮叮头条' },
        //       { index: '/ConteMange/Classif', title: '文章分类' },
        //       { index: '/ConteMange/regionManage', title: '区域管理' },
        //     ]
        //   },
        //   { icon: 'iconfont adv ', index: '/adManage/walletAdv', title: '广告管理' },
        //   { icon: 'iconfont class ', index: '/sortMange/constructTeam', title: '工种类别' },
        //   {
        //     icon: 'iconfont secondhand ',
        //     index: 'Secondhand',
        //     title: '工友/二手',
        //     subs: [
        //       { index: '/Secondhand/nearWorker', title: '工友管理' },
        //       { index: '/Secondhand/WorkerAudit', title: '待审工友？' },
        //       { index: '/Secondhand/workerComment', title: '工友评论' },
        //       { index: '/Secondhand/secondInfo', title: '二手工具' },
        //       { index: '/Secondhand/toolAudit', title: '待审工具？' },
        //       { index: '/Secondhand/secondComment', title: '工具评论' },
        //       { index: '/Secondhand/creditLog', title: '信用管理' },
        //       { index: '/Secondhand/creditAudit', title: '待审信用？' },
        //     ]
        //   },
        //   { icon: 'iconfont sugges ', index: '/suggest/suggest', title: '意见反馈' },
        //   {
        //     icon: 'iconfont member',
        //     index: 'memberManage',
        //     title: '会员管理',
        //     subs: [
        //       { index: '/memberManage/vipRank', title: 'VIP等级管理' },
        //       { index: '/memberManage/upgradeLogs', title: 'VIP升级记录' },
        //       { index: '/memberManage/upgradeTotal', title: 'VIP升级统计' },
        //       { index: '/memberManage/reception', title: '前台会员列表' },
        //       { index: '/memberManage/accessLog', title: '用户访问日志' },
        //       { index: '/memberManage/receptionTotal', title: '前台会员统计' },
        //       { index: '/memberManage/realName', title: '实名认证管理' },
        //       { index: '/memberManage/receiptLevel', title: '用户等级管理' },
        //       { index: '/memberManage/userCraft', title: '会员手艺' },
        //       { index: '/memberManage/waitAudit', title: '待审核手艺' },
        //     ]
        //   },
        //   {
        //     icon: 'iconfont mall',
        //     index: 'mallManage',
        //     title: '商城管理',
        //     subs: [
        //       { index: '/mallManage/category', title: '类别管理' },
        //       { index: '/mallManage/product', title: '产品管理' },
        //       { index: '/mallManage/coupon', title: '优惠管理' },
        //       { index: '/mallManage/order', title: '订单管理' },
        //       { index: '/mallManage/ordercomment', title: '订单评价' },
        //       { index: '/mallManage/address', title: '收货地址' },
        //     ]
        //   },
        //   {
        //     icon: 'iconfont zijin ',
        //     index: 'Accounts',
        //     title: '资金结算',
        //     subs: [
        //       { index: '/Accounts/rechargeTotal', title: '资金统计' },
        //       { index: '/Accounts/CapitalLog', title: '资金日志' },
        //       { index: '/Accounts/redpackLog', title: '红包记录' },
        //       { index: '/Accounts/rechargeCheck', title: '充值核对' },
        //       { index: '/Accounts/returnRecord', title: '返现记录' },
        //       { index: '/Accounts/returnCash', title: '返现提现' },
        //       { index: '/Accounts/returnActivity', title: '返现活动' },
        //     ]
        //   },
        //   {
        //     icon: 'iconfont set',
        //     index: 'sysMange',
        //     title: '系统设置',
        //     subs: [
        //       { index: '/sysMange/AuthMange', title: '权限管理' },
        //       { index: '/sysMange/AccountList', title: '账号列表' },
        //       { index: '/sysMange/wechatMenu', title: '公众号菜单' },
        //       { index: '/sysMange/dictType', title: '数据字典' },
        //       { index: '/sysMange/config', title: '系统配置' },
        //     ]
        //   },
        // ]
      };
    },
    created () {
      this.getCookie();
    },
    computed: {
      ...mapGetters(['isCollapse','menus','isMobile', 'isTopSideMenu'])
    },
    methods: {
      getCookie() {
        let userData = JSON.parse(window.localStorage.getItem('manageLogin'));
        this.totalqyLoginData = {
          userId: userData.userId,
        }
        this.getMenuList();
      },
      async getMenuList() {
        const res = await getMenuList(this.totalqyLoginData.userId);
        if (res.code == 10000) {
          // console.log(res.data)
          this.menuList = res.data;
        } else if  (res.code === 401) {
          this.$message.error({
            showClose: true,
            message: res.message,}
          );
          this.$router.push('/login');
        }
      }
    }
  };
</script>

<style scoped>
  .iconfont {
    margin-right: 10px;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/views/Layout/sidebar.vue